import classNames from 'classnames';
import React from 'react';

interface PropTypes {
  allowedFormats: string[];
  maxFileSizeMb: number;
  maxFilesSizeMb?: number;
  maxTotalFiles?: number;
  errors: any[];
}

export function AttachmentInputFooter(props: PropTypes) {
  return (
    <div
      className={classNames('d-flex', 'flex-column', 'text-dark-200', 'mt-2')}
    >
      {props.errors.map((v, index) => (
        <small key={index} className='text-danger-500'>
          {v.reason}
        </small>
      ))}
      <div className='d-flex'>
        <small>
          {'Allowed file formats: ' + props.allowedFormats.join(', ')}
        </small>
        <small className='ms-auto'>
          {`Max file size: ${props.maxFileSizeMb}MB`}
          {props.maxFilesSizeMb && ` / Total size: ${props.maxFilesSizeMb}MB`}
          {props.maxTotalFiles &&
            ` / Max file attachments: ${props.maxTotalFiles}`}
        </small>
      </div>
    </div>
  );
}
